import React from 'react';
import { useUtmTaxonomyStore } from '@/store/utm-taxonomy-store';
import { Circle, Navigation, Square, Trash2 } from 'lucide-react';

const UtmSelectionToolbar: React.FC = () => {
  const {
    selectionMode,
    setSelectionMode,
    selectionResults,
    clearSelection,
    selectZone,
    selectionFeatures,
    activeSelectionFeatureId,
    removeActiveSelectionFeature,
  } =
    useUtmTaxonomyStore();
  const selectionCount = selectionFeatures.length;

  return (
    <div className="absolute left-2 top-28 z-20 overflow-hidden rounded-lg border border-border bg-card shadow-lg sm:left-4 sm:top-20">
      {/* Header */}
      <div className="flex items-center gap-2 border-b border-border bg-muted px-3 py-2">
        <Navigation size={16} className="text-muted-foreground" />
        <span className="text-sm font-medium text-foreground">Flight zone</span>
        {selectionCount > 0 && (
          <span className="ml-1 inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-muted-foreground/20 px-1.5 text-[11px] font-semibold text-foreground">
            {selectionCount}
          </span>
        )}
      </div>

      {/* Tool Buttons */}
      <div className="flex items-center gap-1 p-2">
        <button
          onClick={() => {
            selectZone(null);
            setSelectionMode('polygon');
          }}
          title="Polygon"
          className={`rounded p-2.5 transition sm:p-2 ${
            selectionMode === 'polygon'
              ? 'bg-primary text-primary-foreground'
              : 'bg-muted text-foreground hover:bg-accent'
          }`}
        >
          <Square size={18} />
        </button>

        <button
          onClick={() => {
            selectZone(null);
            setSelectionMode('radius');
          }}
          title="Disk"
          className={`rounded p-2.5 transition sm:p-2 ${
            selectionMode === 'radius'
              ? 'bg-primary text-primary-foreground'
              : 'bg-muted text-foreground hover:bg-accent'
          }`}
        >
          <Circle size={18} />
        </button>

        <button
          onClick={() => {
            selectZone(null);
            setSelectionMode('corridor');
          }}
          title="Corridor"
          className={`rounded p-2.5 transition sm:p-2 ${
            selectionMode === 'corridor'
              ? 'bg-primary text-primary-foreground'
              : 'bg-muted text-foreground hover:bg-accent'
          }`}
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M3 12 L21 12 M3 8 L21 8 M3 16 L21 16" />
          </svg>
        </button>
      </div>

      {/* Results */}
      {(selectionResults || selectionCount > 0) && (
        <div className="border-t border-border bg-muted px-3 py-2">
          {selectionResults && (
            <div className="mb-2 text-xs text-muted-foreground">
              {selectionResults.zones.length} zone
              {selectionResults.zones.length !== 1 ? 's' : ''} found
            </div>
          )}
          <div className="flex items-center gap-2">
            <button
              onClick={() => void removeActiveSelectionFeature()}
              disabled={!activeSelectionFeatureId}
              className="flex-1 rounded border border-border bg-card px-2 py-1 text-xs text-foreground transition hover:bg-accent disabled:cursor-not-allowed disabled:opacity-50"
            >
              <span className="inline-flex items-center gap-1">
                <Trash2 size={12} />
                Remove
              </span>
            </button>
            <button
              onClick={() => clearSelection()}
              className="flex-1 rounded bg-destructive px-2 py-1 text-xs text-destructive-foreground transition hover:bg-destructive/90"
            >
              Clear
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UtmSelectionToolbar;
